import { EditOutlined } from "@ant-design/icons"
import { Button, Divider } from "antd"
import { SidebarBtn } from "pages/projects/board/components/styled-components/sidebar-btn"
import React from "react"

interface Props extends React.ComponentProps<typeof Button> {
  icon?: React.ReactNode | null
}

export const SidebarButton = (props: Props) => {
  const {
    icon: justReconstruct,
    ...buttonProps
  } = props

  const icon = props.icon !== undefined ? props.icon : <EditOutlined />

  return (
    <>
      <SidebarBtn
        type="ghost"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          ...buttonProps.style,
        }}
        { ...buttonProps }
      >
        <h4 style={{ fontSize: "0.9rem", margin: "0" }}>{
          props.children
        }
        </h4>

        {icon}

      </SidebarBtn>

    </>
  )
}